import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from './api/config';

const AuthModal = ({ onAuthSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleAuth = () => {
    axios.post(`${BASE_URL}/register_or_login.php`, { email, password })
      .then(res => {
        // Fake patient ID logic (ideally from DB response)
        const fakeId = Math.floor(Math.random() * 1000);
        onAuthSuccess(fakeId);
      });
  };

  return (
    <div>
      <input className="form-control my-2" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
      <input className="form-control my-2" type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} />
      <button className="btn btn-primary" onClick={handleAuth}>Sign Up / Login</button>
    </div>
  );
};

export default AuthModal;
